<script lang="ts">
  import ToggleCTA from "@kontextwerk/web-sdk/ui/actions/ToggleCTA.svelte"

  type ActionToggleOption = {
    value: string
    label: string
    icon?: string
    tone?: "primary" | "neutral" | "warning" | "danger"
    ariaLabel?: string
    disabled?: boolean
    tooltip?: string | null
    tooltipContent?: string | null
    dataTestid?: string
  }

  let {
    value,
    options = [],
    disabled = false,
    ariaLabel = "Aktion auswählen",
    wrap = false,
    allowEmptySelection = false,
    onChange,
  }: {
    value: string | null
    options?: ActionToggleOption[]
    disabled?: boolean
    ariaLabel?: string
    wrap?: boolean
    allowEmptySelection?: boolean
    onChange: (value: string) => void
  } = $props()
</script>

<div class="inbox-action-toggle-cell" class:wrap aria-label={ariaLabel}>
  <ToggleCTA
    {options}
    {value}
    {disabled}
    {allowEmptySelection}
    small={true}
    darkMode={false}
    onChange={(next) => onChange(next)}
  />
</div>

<style>
  .inbox-action-toggle-cell {
    align-items: center;
    display: flex;
    min-width: max-content;
  }

  .inbox-action-toggle-cell.wrap {
    max-width: min(24rem, 100%);
    min-width: 0;
    width: fit-content;
  }

  .inbox-action-toggle-cell.wrap :global(.toggle-cta) {
    flex-wrap: wrap;
    max-width: 100%;
  }

  .inbox-action-toggle-cell.wrap :global(.toggle-cta__option),
  .inbox-action-toggle-cell.wrap :global(button.cta.toggle) {
    max-width: 100%;
  }
</style>
